import { ViewModel,View, ObservableArray } from "binder"
import  { EachDistrictSalesView } from "./eachDistrictSales-view"
import { DistrictCancelInvoicePerPersonnel, DistrictInvoicePerCustomer, DistrictInvoicePerPersonnel, DistrictReturnInvoicePerPersonnel, DistrictSale } from "../compareDistrictSales/compareDistrictSales-viewModel";
import moment from "moment";
import { ServerConnection } from "src/server/serverConnection";
import { ServerSideDataLoader, PaginationInfo } from "uicomponents";
import { WindowViewModel } from "src/common/userMainWindow/windowContainer/windowContainer-viewModel";

export class EachDistrictSalesViewModel extends WindowViewModel{
    public getTitle(): string {
        return 'فروش از فروشگاه ها';
    }
    
    GetDefaultView(): View <ViewModel> {
        return new EachDistrictSalesView();
    }
    public getTypeId(): string {
        return "VM-43504FD0-A68E-4400-A3CF-25F178FCFE37"
    }

    constructor(parent:ViewModel) {
        super(parent);
        this.loaderEachDistrict = new ServerSideDataLoader(filteringInformation=>this.getEachDistrictSales(filteringInformation),150);
        this.salesFromEachDistrict = ObservableArray.create<DistrictSale>();
        this.totalSales = ObservableArray.create<TotalSale>();
        this.from = moment.utc();
        this.until = moment.utc();
        this.refresh();
    }
    
    public set from(v: moment.Moment) { 
        let v2 = v.clone().local().hour(4).minute(30).second(0).millisecond(0)
        this._from = v2; 
    } public get from(): moment.Moment { return this._from;} private _from: moment.Moment;
    public set until(v: moment.Moment) { 
        let v2 = v.clone().local().hour(23).minute(59).second(59).millisecond(999)
        this._until = v2; 
    } public get until(): moment.Moment { return this._until;} private _until: moment.Moment;
        
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    public set loaderEachDistrict(v: ServerSideDataLoader) { this._loaderEachDistrict = v; } public get loaderEachDistrict(): ServerSideDataLoader { return this._loaderEachDistrict;} private _loaderEachDistrict: ServerSideDataLoader;
    public set salesFromEachDistrict(v: ObservableArray<DistrictSale>) { this._salesFromEachDistrict = v; } public get salesFromEachDistrict(): ObservableArray<DistrictSale> { return this._salesFromEachDistrict;} private _salesFromEachDistrict: ObservableArray<DistrictSale>;
    public set totalSales(v: ObservableArray<TotalSale>) { this._totalSales = v; } public get totalSales(): ObservableArray<TotalSale> { return this._totalSales;} private _totalSales: ObservableArray<TotalSale>;

    public set totalSaleInvoicesCount(v: number) { this._totalSaleInvoicesCount = v;} public get totalSaleInvoicesCount(): number { return this._totalSaleInvoicesCount;} private _totalSaleInvoicesCount: number;
    public set totalSaleInvoicesFinalPrice(v: number) { this._totalSaleInvoicesFinalPrice = v;} public get totalSaleInvoicesFinalPrice(): number { return this._totalSaleInvoicesFinalPrice;} private _totalSaleInvoicesFinalPrice: number;
    public set totalSaleInvoicesAmount(v: number) { this._totalSaleInvoicesAmount = v;} public get totalSaleInvoicesAmount(): number { return this._totalSaleInvoicesAmount;} private _totalSaleInvoicesAmount: number;
    public set totalReturnInvoicesCount(v: number) { this._totalReturnInvoicesCount = v;} public get totalReturnInvoicesCount(): number { return this._totalReturnInvoicesCount;} private _totalReturnInvoicesCount: number;
    public set totalReturnInvoicesFinalPrice(v: number) { this._totalReturnInvoicesFinalPrice = v;} public get totalReturnInvoicesFinalPrice(): number { return this._totalReturnInvoicesFinalPrice;} private _totalReturnInvoicesFinalPrice: number;
    public set totalCancelInvoicesCount(v: number) { this._totalCancelInvoicesCount = v;} public get totalCancelInvoicesCount(): number { return this._totalCancelInvoicesCount;} private _totalCancelInvoicesCount: number;
    public set totalCancelInvoicesFinalPrice(v: number) { this._totalCancelInvoicesFinalPrice = v;} public get totalCancelInvoicesFinalPrice(): number { return this._totalCancelInvoicesFinalPrice;} private _totalCancelInvoicesFinalPrice: number;
    
    public async refresh() {
        this.loaderEachDistrict.refresh();
    }

    async getEachDistrictSales(filteringInformation:any): Promise<PaginationInfo>{
        try {
            this.isLoading = true;
            let result = await ServerConnection.callServer('/Complex/ReportServices/CompareSalesFromEachDistrict',{
                From:this.from,
                Until:this.until,
                FurtherQueryInfo:filteringInformation
            });
            let rowNumber = 0;
            this.salesFromEachDistrict.clear();
            this.totalSales.clear();
            result.FromDistricts.map(row=>{
                this.salesFromEachDistrict.push(...row.DistrictSales.map(q=>{
                    let r = new DistrictSale(this);
                    r.rowNumber = ++rowNumber;
                    r.customerName = q.CustomerName;
                    r.saleFromDistrictName = row.DistrictName;
                    r.districtName = q.DistrictName;
                    r.saleInvoicesCount = q.SaleInvoicesCount;
                    r.saleInvoicesFinalPrice = q.SaleInvoicesFinalPrice;
                    r.saleInvoicesAmount = q.SaleInvoicesAmount;
                    r.returnInvoicesCount = q.ReturnInvoicesCount;
                    r.returnInvoicesFinalPrice = q.ReturnInvoicesFinalPrice;
                    r.cancelInvoicesCount = q.CancelInvoicesCount;
                    r.cancelInvoicesFinalPrice = q.CancelInvoicesFinalPrice;
                    r.districtInvoicesPerCustomer.update(...q.DistrictInvoicesPerCustomer.map(p=>{
                        let d = new DistrictInvoicePerCustomer(this);
                        d.customerName = p.CustomerName;
                        d.saleInvoicesAmount = p.SaleInvoicesAmount;
                        d.saleInvoicesFinalPrice = p.SaleInvoicesFinalPrice;
                        d.saleInvoicesCount = p.SaleInvoicesCount;
                        d.saleInvoiceItemsCount = p.SaleInvoiceItemsCount;
                        return d;
                    }));
                    r.districtInvoicesPerPersonnel.update(...q.DistrictInvoicesPerPersonnel.map(p=>{
                        let d = new DistrictInvoicePerPersonnel(this);
                        d.personnelName = p.PersonnelName;
                        d.saleInvoicesAmount = p.SaleInvoicesAmount;
                        d.saleInvoicesFinalPrice = p.SaleInvoicesFinalPrice;
                        d.saleInvoicesCount = p.SaleInvoicesCount;
                        d.saleInvoiceItemsCount = p.SaleInvoiceItemsCount;
                        return d;
                    }));
                    r.districtReturnInvoicesPerPersonnel.update(...q.DistrictReturnInvoicesPerPersonnel.map(p=>{
                        let d = new DistrictReturnInvoicePerPersonnel(this);
                        d.customerName = p.CustomerName;
                        d.personnelName = p.PersonnelName;
                        d.invoiceNumber = p.InvoiceNumber;
                        d.creationTime = moment.utc(p.CreatedDate);
                        d.returnInvoicesAmount = p.ReturnInvoicesAmount;
                        d.returnInvoicesFinalPrice = p.ReturnInvoicesFinalPrice;
                        d.returnInvoicesFeePrice = p.ReturnInvoicesFeePrice;
                        d.productCode = p.ProductCode;
                        d.productName = p.ProductName;
                        return d;
                    }));
                    r.districtCancelInvoicesPerPersonnel.update(...q.DistrictCancelInvoicesPerPersonnel.map(p=>{
                        let d = new DistrictCancelInvoicePerPersonnel(this);
                        d.customerName = p.CustomerName;
                        d.personnelName = p.PersonnelName;
                        d.invoiceNumber = p.InvoiceNumber;
                        d.creationTime = moment.utc(p.CreatedDate);
                        d.canceledInvoicesAmount = p.CanceledInvoicesAmount;
                        d.canceledInvoicesFinalPrice = p.CanceledInvoicesFinalPrice;
                        d.canceledInvoicesFeePrice = p.CanceledInvoicesFeePrice;
                        d.productCode = p.ProductCode;
                        d.productName = p.ProductName;
                        return d;
                    }));
                    return r;
                }));
                let r = new TotalSale(this);
                r.rowNumber = this.totalSales.length + 1;
                r.saleFromDistrictName = row.DistrictName;
                let totalofEachDistrict = this.salesFromEachDistrict.filter(a => a.saleFromDistrictName == row.DistrictName);
                r.saleInvoicesCount = totalofEachDistrict.reduce((a,c)=>a + c.saleInvoicesCount, 0);
                r.saleInvoicesFinalPrice = totalofEachDistrict.reduce((a,c)=>a + c.saleInvoicesFinalPrice, 0);
                r.saleInvoicesAmount = totalofEachDistrict.reduce((a,c)=>a + c.saleInvoicesAmount, 0);
                r.returnInvoicesCount = totalofEachDistrict.reduce((a,c)=>a + c.returnInvoicesCount, 0);
                r.returnInvoicesFinalPrice = totalofEachDistrict.reduce((a,c)=>a + c.returnInvoicesFinalPrice, 0);
                r.cancelInvoicesCount = totalofEachDistrict.reduce((a,c)=>a + c.cancelInvoicesCount, 0);
                r.cancelInvoicesFinalPrice = totalofEachDistrict.reduce((a,c)=>a + c.cancelInvoicesFinalPrice, 0);
                this.totalSales.push(r);
                
                return this;
            });
            this.totalSaleInvoicesCount = this.totalSales.reduce((a,c)=>a + c.saleInvoicesCount, 0);
            this.totalSaleInvoicesFinalPrice = this.totalSales.reduce((a,c)=>a + c.saleInvoicesFinalPrice, 0);
            this.totalSaleInvoicesAmount = this.totalSales.reduce((a,c)=>a + c.saleInvoicesAmount, 0);
            this.totalReturnInvoicesCount = this.totalSales.reduce((a,c)=>a + c.returnInvoicesCount, 0);
            this.totalReturnInvoicesFinalPrice = this.totalSales.reduce((a,c)=>a + c.returnInvoicesFinalPrice, 0);
            this.totalCancelInvoicesCount = this.totalSales.reduce((a,c)=>a + c.cancelInvoicesCount, 0);
            this.totalCancelInvoicesFinalPrice = this.totalSales.reduce((a,c)=>a + c.cancelInvoicesFinalPrice, 0);
            
            return new PaginationInfo(result.PaginationInfo.CurrentPage,result.PaginationInfo.PageCount);
        } catch (ex) {
            console.log(ex);
            return new PaginationInfo(0,0);
        } finally {
            this.isLoading = false;
        }
    }
    
}

export class TotalSale extends ViewModel{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:ViewModel) {
        super(parent);
    }

    public set id(v: string) { this._id = v; } public get id(): string { return this._id;} private _id: string;
    public set rowNumber(v: number) { this._rowNumber = v; } public get rowNumber(): number { return this._rowNumber;} private _rowNumber: number;
    public set totalRow(v: boolean) { this._totalRow = v; } public get totalRow(): boolean { return this._totalRow;} private _totalRow: boolean;
    public set customerName(v: string) { this._customerName = v; } public get customerName(): string { return this._customerName;} private _customerName: string;
    public set districtName(v: string) { this._districtName = v; } public get districtName(): string { return this._districtName;} private _districtName: string;
    public set saleFromDistrictName(v: string) { this._saleFromDistrictName = v; } public get saleFromDistrictName(): string { return this._saleFromDistrictName;} private _saleFromDistrictName: string;
    public set sellerName(v: string) { this._sellerName = v; } public get sellerName(): string { return this._sellerName;} private _sellerName: string;
    public set saleInvoicesCount(v: number) { this._saleInvoicesCount = v; } public get saleInvoicesCount(): number { return this._saleInvoicesCount;} private _saleInvoicesCount: number;
    public set saleInvoicesAmount(v: number) { this._saleInvoicesAmount = v; } public get saleInvoicesAmount(): number { return this._saleInvoicesAmount;} private _saleInvoicesAmount: number;
    public set saleInvoicesFinalPrice(v: number) { this._saleInvoicesFinalPrice = v; } public get saleInvoicesFinalPrice(): number { return this._saleInvoicesFinalPrice;} private _saleInvoicesFinalPrice: number;
    public set returnInvoicesCount(v: number) { this._returnInvoicesCount = v; } public get returnInvoicesCount(): number { return this._returnInvoicesCount;} private _returnInvoicesCount: number;
    public set returnInvoicesFinalPrice(v: number) { this._returnInvoicesFinalPrice = v; } public get returnInvoicesFinalPrice(): number { return this._returnInvoicesFinalPrice;} private _returnInvoicesFinalPrice: number;
    public set cancelInvoicesCount(v: number) { this._cancelInvoicesCount = v; } public get cancelInvoicesCount(): number { return this._cancelInvoicesCount;} private _cancelInvoicesCount: number;
    public set cancelInvoicesFinalPrice(v: number) { this._cancelInvoicesFinalPrice = v; } public get cancelInvoicesFinalPrice(): number { return this._cancelInvoicesFinalPrice;} private _cancelInvoicesFinalPrice: number;
    
}